import { totalsChoiceName } from '@brush/ui';
import { usePeriodChoice } from '../periods/context';

/**
 * Which period Overview's totals cards show, as text, with a Change link to Settings → Preferences → Periods
 * (docs/specs/user-preferences.md UP24, A6). The name is the choice in force — All time, a preset's name or Custom
 * range — and the dates beneath are `caption`, the period the server answered for, so they name what the figures are
 * even while a new answer is on its way (`updating`). It is not a control: the choice is made in the Periods card.
 * Chalk on the chalk ground, never signal orange.
 */
export function OverviewTotalsSummary({
  caption,
  updating,
  onChange,
}: {
  caption: string | null;
  updating: boolean;
  onChange: () => void;
}) {
  const [period] = usePeriodChoice('overview.totals');

  return (
    <div className="text-xs text-ink-800/70 sm:text-right">
      <p>
        Totals: <span className="font-semibold text-ink-950">{totalsChoiceName(period)}</span>
        <button
          type="button"
          onClick={onChange}
          className="ml-2 text-ink-800/60 underline underline-offset-2 hover:text-ink-950"
        >
          Change
        </button>
      </p>
      {caption || updating ? (
        <p className="mt-0.5 text-ink-800/60">
          {caption}
          {updating ? <span className={caption ? 'ml-2' : ''}>Updating…</span> : null}
        </p>
      ) : null}
    </div>
  );
}
